// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3wBp9","requiredAsterisk":"Info_requiredAsterisk__2UEZ0"};